export default __webpack_public_path__ + "static/media/nflStaff15.5e419ae8.jpg";